import React, { useState, useEffect } from "react";
import { DateInput } from "@mantine/dates";
import { IconInfoCircle } from "@tabler/icons-react";

function toLocalDate(value) {
	if (!value) return null;
	const d = new Date(value);
	if (isNaN(d.valueOf())) return null;
	return new Date(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
}

function toDateString(date) {
	if (!date) return null;
	const year = date.getFullYear();
	const month = String(date.getMonth() + 1).padStart(2, "0");
	const day = String(date.getDate()).padStart(2, "0");
	return `${year}-${month}-${day}`;
}

export function LabeledDatePicker({
	label,
	name,
	handler,
	defaultValue,
	hoverText,
	disabled,
	isClearable,
	placeholderText,
	className,
}) {
	const [startDate, setStartDate] = useState(null);
	const [unchanged, setUnchanged] = useState(true);

	useEffect(() => {
		if (unchanged && defaultValue) {
			setStartDate(toLocalDate(defaultValue));
		}
	}, [unchanged, defaultValue]);

	const handleChange = (date) => {
		const dateValue = toLocalDate(date);
		setStartDate(dateValue);
		setUnchanged(false);
		handler && handler(name, toDateString(dateValue));
	};

	return (
		<div
			className={
				"LabeledInput LabeledDatePicker " +
				(className || "") +
				(disabled ? "disabled" : "")
			}
		>
			<div style={{ display: "flex" }}>
				<div className="InputLabel">{label}</div>
				{hoverText && (
					<div title={hoverText}>
						<IconInfoCircle
							size={18}
							style={{
								marginLeft: 4,
								verticalAlign: "sub",
							}}
						/>
					</div>
				)}
			</div>
			<DateInput
				value={startDate}
				onChange={handleChange}
				clearable={isClearable && !disabled}
				placeholder={placeholderText}
				disabled={!!disabled}
				valueFormat="MM/DD/YYYY"
				firstDayOfWeek={0}
			/>
		</div>
	);
}
